export default __webpack_public_path__ + "static/media/common-iv-audio.e7549f32.png";